export default __webpack_public_path__ + "static/media/github.cba51bdc.svg";